import { PageTitle } from "Components/Titles";
import { ReadCompany } from "Features/Company";
import { Container } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

function ViewCompany () {

    const { t } = useTranslation();

    return (
        <Container className="page">

            <PageTitle title={t("pages.companyDetail")} />
            <ReadCompany />

        </Container>
    );
}

export default ViewCompany;